import React, { FC } from "react";
import { Maybe } from "@graphql-tools/utils/typings/types";
import { Card } from "antd";
import Title from "antd/lib/typography/Title";
import { useIntl } from "react-intl";

interface RequestAdditionProps {
  addition: Maybe<string> | undefined;
}

export const RequestAddition: FC<RequestAdditionProps> = ({ addition }) => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Title level={3} style={{ fontWeight: "bold" }}>
        {formatMessage({ id: "appointment-request.addition" })}
      </Title>
      <p>{addition}</p>
    </Card>
  );
};
